import { FormGroup } from '@angular/forms';
import * as moment from 'moment';



export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        let value1 = moment(control.value).format('MM/DD/YYYY');
        let value2 = moment(matchingControl.value).format('MM/DD/YYYY')




        if (matchingControl.errors && !matchingControl.errors.error) {
            return;
        }



        if (moment(value2).isBefore(value1)) {
            matchingControl.setErrors({ error: true });
        } else {
            return null
        }
    }



}